module.exports = __webpack_public_path__ + "assets/img/main4.dccba8d5.png";